import ApiBase from '@/api/base';

export default {
  testSend (args) {
    return ApiBase.post(`/admin/mails/test_send`, args);
  },
};
